import {
  GET_POSITIONCHANGE,
  GET_POSITIONCHANGE_SUCCESS,
  GET_POSITIONCHANGE_FAIL,
  DELETE_POSITIONCHANGE,
  DELETE_POSITIONCHANGE_SUCCESS,
  DELETE_POSITIONCHANGE_FAIL,
  UPDATE_POSITIONCHANGE,
  UPDATE_POSITIONCHANGE_SUCCESS,
  UPDATE_POSITIONCHANGE_FAIL,
  ADD_NEW_POSITIONCHANGE,
  ADD_POSITIONCHANGE_SUCCESS,
  ADD_POSITIONCHANGE_FAIL,
  POSITIONCHANGE_LOADING,
  POSITIONCHANGE_RESET
} from "./actionType";

export const resetPositionChangeState = (actionType) => ({
  type: POSITIONCHANGE_RESET,
  payload: { actionType },
});

export const getPositionChangeSuccess = (actionType, data) => ({
  type: GET_POSITIONCHANGE_SUCCESS,
  payload: { actionType, data },
});

export const getPositionChangeFail = (actionType, error) => ({
  type: GET_POSITIONCHANGE_FAIL,
  payload: { actionType, error },
});

export const getPositionChange = data => ({
  type: GET_POSITIONCHANGE,
  payload: data,
});

export const getPositionChangeLoading = () => ({
  type: POSITIONCHANGE_LOADING
});

export const deletePositionChange = data => ({
  type: DELETE_POSITIONCHANGE,
  payload: data,
});

export const deletePositionChangeSuccess = data => ({
  type: DELETE_POSITIONCHANGE_SUCCESS,
  payload: data,
});

export const deletePositionChangeFail = error => ({
  type: DELETE_POSITIONCHANGE_FAIL,
  payload: error,
});

export const updatePositionChange = data => ({
  type: UPDATE_POSITIONCHANGE,
  payload: data,
});

export const updatePositionChangeFail = error => ({
  type: UPDATE_POSITIONCHANGE_FAIL,
  payload: error,
});

export const updatePositionChangeSuccess = data => ({
  type: UPDATE_POSITIONCHANGE_SUCCESS,
  payload: data,
});

export const addNewPositionChange = data => ({
  type: ADD_NEW_POSITIONCHANGE,
  payload: data,
});

export const addPositionChangeSuccess = data => ({
  type: ADD_POSITIONCHANGE_SUCCESS,
  payload: data,
});

export const addPositionChangeFail = error => ({
  type: ADD_POSITIONCHANGE_FAIL,
  payload: error,
});